
/* injects from baggage-loader */

'use strict';

import PageEightController from './page-eight.controller';
import mainTpl from './page-eight.html';

export default class PageEightComponent {
    constructor() {
        this.controller = PageEightController;
        this.templateUrl = mainTpl;
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/page-eight/page-eight.component.js